import { useContext } from 'react';

import GameContext from './context';

export const useGame = () => {
  const config = useContext(GameContext);
  return config;
};

export default useGame;
